export { default } from './SWStandardBanner';
